import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
// Инициализация i18next (side-effect): определяет локаль из window.location.hostname
// и регистрирует react-i18next до первого рендера. См. ./i18n.
import './i18n';
import App from './App';
import './index.css';
import 'katex/dist/katex.min.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    {/* Suspense нужен для ленивой подгрузки каталогов en/cn (Фаза 4, И3):
        react-i18next приостанавливает рендер, пока чанк локали грузится, и
        показывает fallback. На ru (встроенный каталог) подгрузки нет — suspend
        не срабатывает. */}
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </React.StrictMode>,
);
